/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import {HttpClient, HttpResponse} from '@angular/common/http';

import {RemovalPoint} from '../_models/models';
import {Observable} from 'rxjs';
import {RemovalPointType} from '../_forms/removal-point-type';
import {QueryParams, QueryParamsHelper} from '../_helpers/query-params.helper';
import {AbstractService, RESPONSE} from './abstract.service';

@Injectable()
export class RemovalPointService extends AbstractService<RemovalPoint> {

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                              MAGICS METHODS                                                                                        ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  constructor(@Inject(LOCALE_ID) public locale: string, protected httpClient: HttpClient) {
    super(locale, httpClient, 'removal-point', 'removal-points');
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                                                PATCH                                                               ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public addPhoneNumbers(id: number, phoneNumbers: string[], qp?: QueryParams): Observable<HttpResponse<RemovalPoint>> {
    return this.httpClient.patch<RemovalPoint>(`${this.singleUrl}/${id}/add-phone-numbers`, {'phone-numbers': phoneNumbers}, {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp),
      observe: RESPONSE,
      reportProgress: false
    });
  }

  public removePhoneNumbers(id: number, phoneNumbers: string[], qp?: QueryParams): Observable<HttpResponse<RemovalPoint>> {
    return this.httpClient.patch<RemovalPoint>(`${this.singleUrl}/${id}/remove-phone-numbers`,
      {'phone-numbers': phoneNumbers}, {
        headers: QueryParamsHelper.getHttpHeaders(qp),
        params: QueryParamsHelper.getHttpParams(qp),
        observe: RESPONSE,
        reportProgress: false
      });
  }

  public updateFavorite(removalPointId: number, qp?: QueryParams): Observable<HttpResponse<RemovalPoint>> {
    return this.httpClient.patch<RemovalPoint>(`${this.singleUrl}/${removalPointId}/favorite`, null,
      {
        headers: QueryParamsHelper.getHttpHeaders(qp),
        params: QueryParamsHelper.getHttpParams(qp),
        observe: RESPONSE,
        reportProgress: false
      });
  }

  public update(
    removalPointId: number, payload: RemovalPoint | RemovalPointType, qp?: QueryParams
  ): Observable<HttpResponse<RemovalPoint>> {
    return this.httpClient.patch<RemovalPoint>(`${this.singleUrl}/${removalPointId}`, payload, {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp),
      observe: RESPONSE,
      reportProgress: false
    });
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  ///                                                                POST                                                                ///
  //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  public create(
    thirdPartyId: number, payload: RemovalPoint | RemovalPointType, qp?: QueryParams
  ): Observable<HttpResponse<RemovalPoint>> {
    return this.httpClient.post<RemovalPoint>(`${this.baseUrl}/third-party/${thirdPartyId}/removal-point`, payload, {
      headers: QueryParamsHelper.getHttpHeaders(qp),
      params: QueryParamsHelper.getHttpParams(qp),
      observe: RESPONSE,
      reportProgress: false
    });
  }

}
